import { FC, useMemo } from 'react';
import { useIsDarkMode } from 'src/common/hooks/use-is-dark-mode';
import { useIsAskEchoEnabledInCurrentRoom, useIsEchoEnabledInCurrentRoom } from 'src/features/room/room.helpers';
import { AskEchoSelectableText } from 'src/common/components/echo/ask-echo-selectable-text';
import { replaceContent, replaceContentForTaskBreakdownRooms, replaceContentForCombineAttackboxExperiment } from 'src/features/room/helpers/content-replacer';
import { AccordionDetailsProps } from './accordion-details.types';
import { StyledAccordionDetailsMain } from './accordion-details.styles';
export const AccordionDetails: FC<AccordionDetailsProps> = ({
  description: taskContent,
  title: taskTitle,
  taskNo,
  glossaryData,
  machineIP,
  attackBoxPrivateIP,
  shouldSeeVmStart,
  currentAzureLabId,
  roomCode,
  isAttackboxWidgetV1ExperimentEnabled,
  isAttackboxWidgetV2ExperimentEnabled,
  isTaskBreakdownSupported,
  taskId
}): JSX.Element => {
  const isDarkMode = useIsDarkMode();
  const isEchoEnabled = useIsEchoEnabledInCurrentRoom();
  const isAskEchoEnabled = useIsAskEchoEnabledInCurrentRoom();
  const isEchoEnabledAndAskEchoEnabled = !!isEchoEnabled && isAskEchoEnabled;
  const refinedContent = useMemo(() => {
    let content = replaceContent(taskContent, glossaryData, machineIP, attackBoxPrivateIP, shouldSeeVmStart, currentAzureLabId);
    if (isAttackboxWidgetV1ExperimentEnabled || isAttackboxWidgetV2ExperimentEnabled) {
      content = replaceContentForCombineAttackboxExperiment(roomCode, content);
    }
    if (isTaskBreakdownSupported) {
      content = replaceContentForTaskBreakdownRooms({
        roomCode,
        content,
        taskTitle,
        taskNo
      });
    }
    return content;
  }, [taskContent, glossaryData, machineIP, attackBoxPrivateIP, shouldSeeVmStart, currentAzureLabId, taskTitle, isAttackboxWidgetV1ExperimentEnabled, isAttackboxWidgetV2ExperimentEnabled, isTaskBreakdownSupported, roomCode, taskNo]);
  return isEchoEnabledAndAskEchoEnabled ? <AskEchoSelectableText taskId={taskId} roomCode={roomCode}>
      <StyledAccordionDetailsMain dangerouslySetInnerHTML={{
      __html: refinedContent
    }} $isTaskBreakdownSupported={!!isTaskBreakdownSupported} $isDarkMode={isDarkMode} $isAskEchoEnabled={isEchoEnabledAndAskEchoEnabled} />
    </AskEchoSelectableText> : <StyledAccordionDetailsMain dangerouslySetInnerHTML={{
    __html: refinedContent
  }} $isTaskBreakdownSupported={!!isTaskBreakdownSupported} $isDarkMode={isDarkMode} $isAskEchoEnabled={isEchoEnabledAndAskEchoEnabled} />;
};